import { useState, useCallback } from 'react';
import { preferencesService } from '../../services/api';
import { userKey } from '../../utils/userStorage';

// Préférences UX examen/quiz, stockées dans le même JSON `dashboardPrefs` (synchronisé serveur
// + multi-appareils). On lit le cache localStorage pour un affichage instantané, et on pousse
// chaque changement en partiel via preferencesService.save (le backend fusionne + whitelist —
// cf. backend/api/v1/user/preferences.php). Deux clés PLATES (pas d'objet imbriqué) car le
// merge serveur est superficiel : un objet imbriqué écraserait ses clés sœurs.
//
// - examPauseSec : secondes d'inactivité avant mise en pause auto (0 = jamais).
// - examShowAllAnswers : afficher toutes les réponses en relecture / flash (sinon on ne montre
//   que la réponse choisie + la bonne).

const STORAGE_KEY = 'nizus_dashboard_prefs';
const DEFAULT_PAUSE_SEC = 60;

// Presets exposés dans l'UI (en secondes ; 0 = jamais).
export const PAUSE_PRESETS = [30, 60, 120, 300, 0];

function readPrefs() {
    try {
        const raw = localStorage.getItem(userKey(STORAGE_KEY));
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
}

function writeLocal(patch) {
    try {
        const next = { ...readPrefs(), ...patch };
        localStorage.setItem(userKey(STORAGE_KEY), JSON.stringify(next));
    } catch { /* quota / private browsing */ }
}

const useExamPrefs = () => {
    const [pauseSec, setPauseSecState] = useState(() => {
        const v = readPrefs().examPauseSec;
        return (typeof v === 'number' && v >= 0) ? v : DEFAULT_PAUSE_SEC;
    });
    const [showAllAnswers, setShowAllState] = useState(() => !!readPrefs().examShowAllAnswers);

    const setPauseSec = useCallback((sec) => {
        const v = Math.max(0, parseInt(sec, 10) || 0);
        setPauseSecState(v);
        writeLocal({ examPauseSec: v });
        preferencesService.save({ examPauseSec: v }).catch(() => {});
    }, []);

    const setShowAllAnswers = useCallback((val) => {
        const v = !!val;
        setShowAllState(v);
        writeLocal({ examShowAllAnswers: v });
        preferencesService.save({ examShowAllAnswers: v }).catch(() => {});
    }, []);

    return { pauseSec, showAllAnswers, setPauseSec, setShowAllAnswers };
};

export default useExamPrefs;
